import {
  destroyShare,
  getShareToken,
  leaveShare,
  rescindShare,
} from '../services/udapi/sharing';
// import ghAnalytics from '../lib/analytics';
import noop from 'lodash-es/noop';

export default {
  namespace: 'share',
  state: {
    sharedFeature: null,
    shareToken: null,
  },
  effects: {
    *createShare({ callback = noop, payload }, { call }) {
      const { grantableType, grantableId } = payload;
      const response = yield call(getShareToken, grantableType, grantableId);

      if (response.data) {
        const shareLink = response.data.shortUrl;

        callback(shareLink);
      } else {
        callback(null);
      }
    },
    *destroyShare({ callback = noop, payload }, { call }) {
      const { grantableType, grantableId, grantIndex } = payload;
      const response = yield call(destroyShare, grantableType, grantableId);

      if (response.data) {
        callback(true);
      } else {
        callback(null);
      }
    },
    *rescindShare({ callback = noop, payload }, { call }) {
      const { grantableType, grantableId, grantIndex } = payload;
      const response = yield call(rescindShare, grantableType, grantableId, grantIndex);
      

      if (response.data) {
        callback();
      } else {
        callback(null);
      }
    },
    *leaveShare({ callback = noop, payload}, { call }) {
      const { grantableType, grantableId } = payload;

      let response = yield call(leaveShare, grantableType, grantableId);
      
      if (response.success) {
        callback(true);
      } else {
        callback(false);
      }
    }
  },
  reducers: {
    setSharedFeature(state, { payload: sharedFeature }) {
      return {
        ...state,
        sharedFeature,
      };
    },
    setShareToken(state, { payload: shareToken }) {
      return {
        ...state,
        shareToken,
      };
    },
    resetShare(state) {
      return {
        ...state,
        sharedFeature: null,
        shareToken: null,
      };
    }
  }
};